import { FaCode, FaCloud, FaGraduationCap } from "react-icons/fa";
import { motion } from "framer-motion";

export default function Services() {
  return (
    <section className="services" id="services">
      <h2>Our Services</h2>

      <div className="service-grid">
        <motion.div whileHover={{ y: -8 }} className="service-card">
          <FaCode />
          <h3>System & Web Development</h3>
          <p>
            We design and develop secure, scalable websites and systems tailored
            to your business needs using modern technologies.
          </p>
        </motion.div>

        <motion.div whileHover={{ y: -8 }} className="service-card">
          <FaCloud />
          <h3>SaaS Solutions</h3>
          <p>
            We build cloud-based software solutions designed to improve operations,
            efficiency and digital transformation.
          </p>
        </motion.div>

        <motion.div whileHover={{ y: -8 }} className="service-card">
          <FaGraduationCap />
          <h3>Ellentra Academy</h3>
          <p>
            Empowering individuals with practical tech skills through training,
            mentorship and real-world learning experiences.
          </p>
        </motion.div>
      </div>
    </section>
  );
}
